<template>
  <v-sheet tile color="white" class="fill-height">
    <v-container align="center">
      <v-row justify="center">
        <v-col cols="12" lg="4">
          <div class="title">Switch to different role</div>
          <br/>
          <v-list three-line subheader>
            <v-form v-model="isValid">
              <v-select required outlined label="Switch Into" v-model="role" :items="possibleRoles" item-value="name"
                        :rules="[v => !!v || 'Please select a value']"
                        item-text="name"></v-select>
              <v-select required outlined :label="itemsCaption" v-if="should_select_item" v-model="item_id"
                        :rules="[v => !!v || 'Please select a value']"
                        :items="availableItems" item-value="id" item-text="name"></v-select>
              <v-col align="right">
                <v-btn color="primary" @click="setRole" :disabled="!isValid">Switch Role</v-btn>
                <v-btn color="primary" @click="logout">Logout</v-btn>
              </v-col>
            </v-form>
          </v-list>
        </v-col>
      </v-row>
    </v-container>
  </v-sheet>
</template>

<script>
  import {mapGetters} from "vuex";
  import {AmplifyPlugin, AmplifyEventBus} from 'aws-amplify-vue';

  export default {
    name: "SwitchPage",
    data: function () {
      return {
        role: undefined,
        item_id: undefined,
        isValid: false
      }
    },
    methods: {
      logout() {
        this.$Amplify.Auth.signOut()
          .then(() => {
            return AmplifyEventBus.$emit('authState', 'signedOut')
          })
      },
      setRole() {
        this.$store.dispatch('setRole', {role: this.role, item_id: this.item_id})
        this.$router.push(this.getDefaultPage)
      }
    },
    computed: {
      ...mapGetters([
        'getDefaultPage',
        'currentRole',
        'possibleRoles',
        'getCurrentBrand',
        'getCurrentStore',
      ]),
      itemsCaption() {
        if (this.role == 'Brand Manager') {
          return "Brand"
        }
        return "Store"
      },
      should_select_item() {
        if (this.role == 'Brand Manager' || this.role == 'Store Manager' || this.role == 'Security') {
          return true
        }
        return false
      },
      availableItems() {
        var results = [];
        if (this.role == 'Brand Manager' || this.role == 'Store Manager' || this.role == 'Security') {
          return this.possibleRoles.find((item) => item.name == this.role).items
        }
        return []
      },
    },
    mounted() {
      this.$store.dispatch('reloadBrandsStores')
      this.role = this.currentRole
      if (this.role == 'Brand Manager') {
        this.item_id = this.getCurrentBrand
      }
      if ((this.role == 'Store Manager') || (this.role == 'Security')) {
        this.item_id = this.getCurrentStore
      }
    }
  }
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/Pages/SwitchPage.vue